
import { Typography, Grid, CircularProgress } from "@mui/material";
import { Modal } from "../Modal/Modal";
import { ModalBody } from "../Modal/ModalBody";

export const ModalLoading: React.FC<any> = (props): JSX.Element | any => {
    const { open, title, text, closeModal, clearState, onConfirm, status=false } = props;
  
    return (
      <>
      <Modal open={open} handleClose={closeModal} disableEscapeKeyDown disableBackdropClick size="xs">
        <ModalBody>
          <Grid xs={12} display='column' justifyContent='center'>
            <Grid display='flex' justifyContent='center'>
              <Typography variant="subtitle1" className="textColor"> 
                {text || 'Cargando Datos..'}
              </Typography>
            </Grid>
            <Grid display='flex' justifyContent='center'>
              {
                status && (
                  <CircularProgress color="inherit" size={13} sx={{ color: 'black', marginLeft: "10px" }} />
                )
              }
            </Grid>
          </Grid>
        </ModalBody>
      </Modal>
      </>
    )
}